import { html } from 'lit';
import type { TefComsCancelButton } from '@src/components/TefComsCancelButton';

// a cancel button that triggers an event
export const tefComsCancelButton = function render(this: TefComsCancelButton) : ReturnType<typeof html> {
  return html`<button class="button button-default--prio-secondary" @click=${this.handleClick}>Dialog schließen</button>`;
};
